module.exports = __webpack_public_path__ + "static/media/slide3.c2045d99.jpeg";